import React from 'react';
import { ExtendedTheme } from 'neon-design-system';
import { Box, Paper, createStyles, makeStyles } from '@material-ui/core';
import Skeleton from './Skeleton';

const useStyles = makeStyles<ExtendedTheme>((theme: ExtendedTheme) => createStyles({
	root: {
		minHeight: 64,
		padding: 16,
		display: 'flex',
		alignItems: 'center'
	},
	avatar: {
		width: `${theme.spacing(4)}px !important`,
		height: `${theme.spacing(4)}px !important`
	},
	topSkeleton: {
		marginTop: 8
	},
	bottomSkeleton: {
		width: `${theme.spacing(15)}px !important`
	}
}));


export const SkeletonContributorCard = () => {
	const classes = useStyles();

	return (
		<Paper className={classes.root}>
			<Skeleton
				type="avatar"
				dataLoaded={false}
				className={classes.avatar}
			/>
			<Box ml={2}>
				<Skeleton
					dataLoaded={false}
					className={classes.topSkeleton}
				/>
				<Skeleton
					dataLoaded={false}
					className={classes.bottomSkeleton}
				/>
			</Box>
		</Paper>
	);
};

export default SkeletonContributorCard;
